import { FeedbackDto, CreateFeedbackRequestDto } from '@careapp-group/ng-sdk';
import * as actions from '../actions/index';

import { CaEntityState } from '../entity-state/entity-state';
import { CaEntityReducer } from '../entity-state/entity-reducer';
import { BaseFilterType } from '../entity-state/entity-actions-factory';

export interface FeedbackState extends CaEntityState<FeedbackDto> {}

export class FeedbackReducer extends CaEntityReducer<FeedbackDto, BaseFilterType> {}

export const state = new FeedbackReducer(actions.Feedback);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
